import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export interface BreadcrumbItem {
    name: string;
    url: string;
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
    className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = '' }) => {
    return (
        <nav aria-label="breadcrumb" className={`flex items-center text-sm text-gray-600 ${className}`}>
            <ol className="flex items-center space-x-2">
                {/* Home link */}
                <li>
                    <Link
                        to="/"
                        className="flex items-center hover:text-[#2f5c96] transition-colors"
                        aria-label="Home"
                    >
                        <Home className="w-4 h-4" />
                    </Link>
                </li>

                {items.map((item, index) => {
                    const isLast = index === items.length - 1;

                    return (
                        <React.Fragment key={index}>
                            <li>
                                <ChevronRight className="w-4 h-4 text-gray-400" />
                            </li>
                            <li>
                                {isLast ? (
                                    <span className="text-gray-900 font-medium" aria-current="page">
                                        {item.name}
                                    </span>
                                ) : (
                                    <Link
                                        to={item.url}
                                        className="hover:text-[#2f5c96] transition-colors"
                                    >
                                        {item.name}
                                    </Link>
                                )}
                            </li>
                        </React.Fragment>
                    );
                })}
            </ol>
        </nav>
    );
};
